<script lang="ts" setup>
import { provide, shallowRef } from 'vue'
import router from '~/router'
import { LayoutComponents } from '~/layouts'

const layout = shallowRef<typeof LayoutComponents>()

router.afterEach((to) => {
  layout.value = LayoutComponents[to.meta.layout]
})

provide('app:layout', layout)
</script>

<template>
  <main>
    <component :is="layout || 'div'">
      <slot />
    </component>
  </main>
</template>
